import { useFormikContext } from 'formik'
import type { ActivityType } from '../../../../typings'

export function useData() {
  const { dirty, isValid, isSubmitting } = useFormikContext<ActivityType>()
  const disableSave = !dirty || isSubmitting || !isValid

  return {
    disableSave,
  }
}
